import React, { useEffect, useState } from "react";
import { Suspense } from "react";
import { useHistory } from "react-router-dom";
import { generatePath } from "react-router";

import * as paths from "../../../../routes/paths";

// Material UI
import { Box, Typography, useMediaQuery } from "@material-ui/core";

//components
import StatusCourseCard from "../../../../design-system/components/Cards/StatusCourseCard/StatusCourseCard";
import DisabledCourseCard from "../../../../design-system/components/Cards/DisabledCourseCard/DisabledCourseCard";
import { ENROLLMENT_STATUS } from "../../../../design-system/constants/enrollment-status";
import { getSourceBySourceAndCompany } from "../../../../design-system/utils/source";
import ModalClassEnrollment from "../../../../shared/components/ModalClassEnrollment/ModalClassEnrollment";

//ver si usar
import { convertSourceToImageResource } from "../../../../../src/constants/placeholderImages";
import getConnectionAllies from "../../../../shared/components/Allies/AlliesConnect";
import { log } from "../../../../shared/utils/console.js";
import { useSelector, useDispatch } from "react-redux";
import { validateMembership, redirectMembershipView } from "../../../../shared/utils/membershipUtils.js";

// Paths
import { CURSO_DETALLE } from "../../../../routes/paths";

// SDK Point
import { ProductService } from "@sdk-point/talisis";

// Constants
import { MEMBERSHIPS } from "../../../../shared/constants/memberships";

// Styles
import useStyles from "../../../../assets/styles/jss/pages/courses/academiesSectionStyle";

const AVAILABLE_COURSE = 0;

const CardProgramListExpand = (props) => {
  const user = useSelector((state) => state.userReducer.user);
  const dispatch = useDispatch();
  const isResponsive = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const history = useHistory();
  const classes = useStyles();

  const membershipIsExpired = validateMembership(props.userMembership);

  const { areaPriorityEnroll = null, is_optative } = props;

  const [NoAvailable, setNotAvailable] = useState(0);
  const [modalProps, setModalProps] = React.useState({
    open: false,
    loading: false,
    course: null,
    error: null,
  });

  useEffect(() => {
    const no_available = Object.hasOwn(props, "no_available")
      ? props.no_available
      : AVAILABLE_COURSE;
    setNotAvailable(no_available);
    if (props.remaining_credits === 0 && !props.is_estadia_empresarial) {
      setNotAvailable(1);
    }
  }, []);

  const [img, setImg] = useState(props.image_url);

  useEffect(() => {
    if (img === null) {
      const newImg = convertSourceToImageResource(
        props.company_id,
        props.source_id
      );
      setImg(newImg);
    }
  }, [img, props.company_id, props.source_id]);

  const productService = new ProductService(
    process.env.REACT_APP_ENV,
    process.env.REACT_APP_X_API_KEY
  );

  const handleRedirectMembership = (e) => {
    redirectMembershipView(e, dispatch, history);
  };

  const handleClickGoToCourse = (course) => async () => {
    const route =
      window.location.protocol +
      "//" +
      window.location.host +
      "/redireccionando/" +
      course.source_id;
    let win = window.open(route, "_blank");
    goToCourse(win, course);
  };

  const handleClickGoToDetail = (courseId) => () => {
    history.push(generatePath(CURSO_DETALLE, { id: courseId }));
  };

  // El acceso depende solo del estado de la membresía. La calificación de una
  // materia ya cursada no otorga derecho a inscribirse de nuevo: la tarjeta se
  // encarga de seguir mostrando la nota cuando el acceso está bloqueado.
  const stateMembership = () => membershipIsExpired;

  const goToCourse = async (win, course) => {
    try {
      const body = {
        person_id: user?.person_id,
        email: user?.email,
        ou: user?.ou,
        course_url: course.course_url,
        source_id: course.source_id,
        course_url_neo: course.course_url_neo,
        course_id: course.course_id,
        company_id: course.company_id,
      };

      var urlRespuesta = await getConnectionAllies(body);

      setTimeout(() => {
        win.focus();
        win.location.replace(urlRespuesta);
      }, 3000);
    } catch (error) {
      log(error);
    }
  };

  const handleClickEnrollment = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (props.blocked) return;
    setModalProps({
      ...modalProps,
      open: true,
      loading: false,
      error: null,
      course: props,
    });
  };

  const handleOnCloseModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setModalProps({ ...modalProps, open: false, course: null });
  };

  const handleOnConfirmModal = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      setModalProps({ ...modalProps, loading: true });
      // const body = {
      //     course_id: modalProps.course?.course_id,
      //     source_id: modalProps.course?.source_id,
      //     level_id: modalProps.course?.level_id,
      //     course_session_id: modalProps.course?.course_session_id,
      //     company_id: modalProps.course?.company_id,
      //     course_program: modalProps.course?.program_id,
      //     person_id: user.person_id,
      //     course_price:0,
      //     isSecondEnrrollment: modalProps.course?.isSecondEnrrollment,
      // };

      // console.log('body insert', body);
      // const responseEnrollment = await membershipService.postMembershipCourseEnrollment(body);
      // log(responseEnrollment);

      const body = {
        person_id: user.person_id,
        course_id: modalProps.course?.course_id,
        program_id: modalProps.course?.program_id,
      };

      if (is_optative) {
        console.log("body insert areaPriorityEnroll", areaPriorityEnroll);
        body.parameters = { area_priority: areaPriorityEnroll };
      }
      if (modalProps.course?.isSecondEnrrollment) {
        body.parameters = {
          ...body.parameters,
          isSecondEnrrollment: modalProps.course?.isSecondEnrrollment
        };
      }
      if (modalProps.course?.isThirdEnrollment) {
        body.parameters = {
          ...body.parameters,
          isThirdEnrollment: modalProps.course?.isThirdEnrollment
        };
      }
      console.log("body insert", body);
      const responseEnrollment = await productService.postProductEnrollment(
        body
      );

      log(responseEnrollment);

      setModalProps({ ...modalProps, loading: false, open: false });
      handleContinueToClass(modalProps.course);
      //history.push(paths.CURSOS);
      window.location.href = paths.CURSOS;
    } catch (e) {
      console.log("error cathc", e);
      setModalProps({ ...modalProps, loading: false, error: e?.message });
    }
  };

  const handleContinueToClass = async (course) => {
    const body = {
      person_id: user?.person_id,
      email: user?.email,
      ou: user?.ou,
      course_url: course.course_url,
      source_id: course.source_id,
      course_url_neo: course.course_url_neo,
      course_id: course.course_id,
      company_id: course.company_id,
      course_name: course?.name,
    };
    const win = window.open(
      window.location.protocol +
        "//" +
        window.location.host +
        "/redireccionando/" +
        course?.source_id,
      "_blank"
    );

    var urlRespuesta = await getConnectionAllies(body);
    setTimeout(() => {
      win.focus();
      win.location.replace(urlRespuesta);
    }, 3000);
  };

  // Determina si el curso debe ser bloqueado para usuarios con membresía Freemium.
  const isFreemiumBlocked =
    props.userMembership?.id === MEMBERSHIPS.FREEMIUM ||
    props.userMembership?.remaining_days_before_expired < -8;

  return (
    <>
      <Suspense fallback={<div></div>}>
        {
          isFreemiumBlocked &&
          (props.enrollment_status_id === ENROLLMENT_STATUS.ENROLLED ||
            props.enrollment_status_id === ENROLLMENT_STATUS.PAUSED) &&
          props.progress_percentage !== 100 ? (
            <DisabledCourseCard
              courseId={props.course_id}
              sourceIdLogo={getSourceBySourceAndCompany(
                props.source_id,
                props.company_id
              )}
              media={{
                backgroundImage: img,
                modalityId: props.modality_id,
              }}
              content={{
                courseName: props.name,
              }}
              handleRenovationMembership={handleRedirectMembership}
            />
          ) : (
            <StatusCourseCard
              courseId={props.course_id}
              userId={parseInt(user.person_id ?? 0)}
              sourceIdLogo={getSourceBySourceAndCompany(
                props.source_id,
                props.company_id
              )}
              enrollmentStatusId={props.enrollment_status_id}
              noAvailable={NoAvailable}
              tagPeriodo={props.tagPeriodo}
              media={{
                backgroundImage: img,
                modalityId: props.modality_id,
                percentage: props.progress_percentage,
                isOptative: props.is_optative,
                isNew: props.isNew,
                grade: props.grade,
              }}
              content={{
                courseName: props.name,
                grade: props.progress_percentage === 100 ? props.grade : false,
                isOptative: props.is_optative,
                enrollmentNotAvailable: props.enrollmentNotAvailable,
                isEnrrollment: props.isEnrollment,
              }}
              isLogged={true}
              onClickGoToCourse={handleClickGoToCourse(props)}
              onClickRegister={handleClickEnrollment}
              onClickGoToDetail={handleClickGoToDetail(props.course_id)}
              showDetailButton={false}
              approved={props.progress_percentage === 100
                ? (props.approved ?? false)
                : null
              }
              userMembership={props.userMembership}
              isSecondEnrrollment={props.isSecondEnrrollment}
              isThirdEnrollment={props.isThirdEnrollment}
              blocked={props.blocked}
              blockedReason={props.blockedReason}
              blockedByCourseName={props.blockedByCourseName}
              isEstadia={props?.is_estadia_empresarial === true}
              estadiaLink={
                props?.is_estadia_empresarial === true && (
                  props.status === 2 ||
                  (props.status === 0 && props.progress_percentage === 100 && props.approved === false)
                )
                  ? props?.estadia_link
                  : undefined
              }
              startDate={
                props?.is_estadia_empresarial === true && (
                  props.status === 2 ||
                  (props.status === 0 && props.progress_percentage === 100 && props.approved === false)
                )
                  ? props?.estadia_start_date
                  : undefined
              }
              merbershipIsExpired={stateMembership()}
              handleRenovationMembership={handleRedirectMembership}
            />
          )
        }
      </Suspense>
      <ModalClassEnrollment
        {...modalProps}
        onClose={handleOnCloseModal}
        onConfirm={handleOnConfirmModal}
        isSecondEnrrollment={props.isSecondEnrrollment}
        isThirdEnrollment={props.isThirdEnrollment}
        coordinatorEmail={props.coordinatorEmail}
      />
    </>
  );
};

export default CardProgramListExpand;
